import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const renderMessage = (props) => <FormattedMessage {...props} />;
export const IntlMessage = injectIntl(renderMessage, { withRef: false });
export default IntlMessage;
